import React from "react";

import { css } from "@emotion/react";

import { Spinner } from "./Spinner";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

export const StyledSpinner: ReactTFC = props => {
  return (
    <div
      css={css`
        width: 36px;
        height: 36px;
        padding: 6px;

        z-index: 300;
      `}
    >
      <Spinner />
    </div>
  );
};

export const SmallStyledSpinner: ReactTFC = props => {
  return (
    <div
      css={css`
        width: 24px;
        height: 22px;

        z-index: 300;
      `}
      {...props}
    >
      <Spinner />
    </div>
  );
};
